import { createStore } from 'vuex'

export default createStore({
  state: {
    status: {
      code: ''
    },
    invoiceStatus: {
      code: null,
      message: null
    }
  },
  mutations: {
    SET_STATUS(state, value) {
      state.status = value
    },
    SET_INVOICE_STATUS(state, value) {
      state.invoiceStatus = value
    }
  },
  actions: {
    setStatus({ commit }, value) {
      commit('SET_STATUS', value)
    },
    setInvoiceStatus({ commit }, value) {
      commit('SET_INVOICE_STATUS', value)
    }
  },
  getters: {
    code: state => state.status.code,
    invoiceStatus: state => state.invoiceStatus
  },
  modules: {}
})
